import React, { Fragment, useState, useEffect } from "react";
import update from "immutability-helper";
import { Listbox, Tab, Transition } from "@headlessui/react";
import { useSelector, useDispatch } from "react-redux";
import { AppState } from "../../../../../stateManager/store";
import { getValue, capitalize, getVisibility, getComponents } from "../helpers";
import {
  updateElement,
  updateModalContent,
  updateCanvasConfig,
  pushFormActionStack,
  updateElementOnUndoRedo,
} from "../../../../../stateManager/store/formCreation_v2/actions";
import { EditorPanel } from "./EditorPanel";
import { useParams } from "react-router-dom";
import { myRedoStack, myUndoStack } from "../stack/Stack";
// import { getValue, capitalize, getVisibility } from "../helpers";
import { useDebouncedAction } from "../../../../../helpers/commonFunction";
// icons
import { ReactComponent as DropdownIcon } from "../../../../../assets/svg/solobuilder/dropdown.svg";
import { ReactComponent as ExpandDarkIcon } from "../../../../../assets/svg/solobuilder/expanddark.svg";
import { ReactComponent as ExpandIcon } from "../../../../../assets/svg/solobuilder/expandlight.svg";
import { ReactComponent as NoData } from "../../../../../assets/svg/noData.svg";
import timelineDefaultTemplate from "../../../../../assets/svg/timelineTemplates/template1.svg";
import EditorIcon from "../../../../../assets/svg/editorIcon.svg";
import {
  setCondBackground,
  setCondColor,
  setTitleFontColor,
  setSubTitleFontColor,
  setBadgeFontColor,
} from "../../../../../stateManager/store/table/actions";
import FixedColumn from "./fixedColumns";
import { AddExpansion } from "./panelExpansion/AddExpansion";
import { ColorPicker, ColorPickerMenu } from "./ColorPicker";
import "./panel.css"
import { getFunctions } from "../../../Assisted/forms/create/properties/commonFunctions";
import ToggleSwitch from "./toggleSwitch";
import { onSetBgdMenuVisibility, onSetBorderVisibility, onsetClrPicContext, onsetDropShadowVisibility, onSetFontStylesVisibility,  onSetTextEditorVisibility, onSetErrorFontStylesVisibility, setFunctions } from "../../../../../stateManager/store/common/action";
import { DropShadow, DropShadowMenu } from "./DropShadow";
import { HtmlandCssEditor } from "./HtmlCodeEditor";
import { MarkdownEditor } from "./MarkdownEditor";
import { ReactComponent as IIcon } from "../../../../../assets/svg/solobuilder/components/iIcon.svg";
import { Popover, Select } from "antd";
import TextEditorPopper from "./textEditor/TextEditorPopper";
import InputWithOption from "./inputWithOption/InputWithOption";
import Border from "./border/Border";
import BorderPopper from "./border/BorderPopper";
import FontStyles from "./fontStyles/FontStyles";
import FontStylesPopper from "./fontStyles/FontStylesPopper";
import {FilterExpansion} from "./panelExpansion/filterExpansion";
// import { FontFamilyExpansion } from "./panelExpansion/fontFamilyExpansion";
import I18AutoCompletion from "../../../Assisted/forms/create/properties/I18NAutoComplete";
import CustomAutoComplete from "../../../Assisted/forms/create/properties/customAutoComplete";
import {ApplyBackgroundImage, BackgroundImageMenu} from "./BackgroundImageMenu";
import MarkDownIcon from "../../../../../assets/svg/markdown.svg";
import { WizardStyle } from "./panelExpansion/WizardStyle";
import { setStepIndex } from "../../../../../stateManager/store/onboarding/action";
import { OnLoadData } from "./ChartOnload";
import { isChildOfFlatList } from "../helpers/getVisibility";
import {Http} from "../../../../../helpers/axois";
import { addDays, addMonths, addYears, format, subDays, subMonths, subYears } from "date-fns";
import TableTemplate1 from "../../../../../assets/svg/tableTempletes/template1.svg";
import DatePickerPropertyPanel from "./DatePickerPropertyPanel";
import moment from "moment";

interface DateRange {
  startDate: Date | null;
  endDate: Date | null;
  key: string;
}

interface IPanel {
  section: "properties" | "layout" | "validation" | "data";
  isCheckedIn?: any;
  setShowTemplates?: any;
  setShowTimelineTemplate?: any;
  setDeviceType?: any;
}
interface IPanel {
  section: "properties" | "layout" | "validation" | "data";
  isCheckedIn?: any;
}

interface Config {
  [key: string]: {
    section: "properties" | "layout" | "validation" | "data" | "canvas";
    key?: string;
    label: string;
    type: Function | string | "bind" | "DoubleInput" | "toggleSwitch" | "divider" | "dotted-divider" | "templete" | "text" | "dropDownInput_fixedCol" | "dropDownInput_colAlign" | "ColorPicker" | "autoRefresh" | "ReviewShape" | "InputWithIcon" | "Tags" | "backgroundImage" | "chartTemplate" | "EventCallback";
    default: string | number | boolean;
    values?: { label: string; value: string | number | boolean; icon: any; selectedIcon?: any;selectedButtonIcon?:any }[];
    placeholder?: string;
    condition?: string;
    panel?: any;
    value?: any;
    label1?: string;
    label2?: string;
    tabList?: any;
    placeholder1?: string;
    placeholder2?: string;
    min?: string;
    max?: string;
    title?: string;
    regex?: string;
    mode?:string;
    category?: string;
    className?: string
  };
}


interface IBorderContext {
  where:string,
  placeholder:string;
  type?: string;
  [key: string]: any;
  label:string;
  value: {
    color:string;
    stroke:string;
    radius:{
      overAll:number;
      topRight:number;
      bottomRight:number;
      bottomLeft:number;
      topLeft:number;
    },
    border:{
      overAll:number;
      top:number;
      right:number;
      bottom:number;
      left:number;
    }
  }
}
const flatlistChildLabels=[
  "Render On",
  "Options Data"
]

export const Panel: React.FC<IPanel> = (props: any) => {
  const { selectedElementId, deviceType, canvasConfig } = useSelector(
    (state: AppState) => state.formJson
  );
  const { components } = getComponents();
  const component = components[selectedElementId] || {};

  const { section, isCheckedIn } = props;
  const dispatch = useDispatch();
  const [config, setConfig] = useState<Config>({});
  const [openHtmlandCssEditor, setOpenHtmlandCssEditor] = useState({
    visibility: false,
    type: "",
    source: "",
    where: "",
  })
  const properties: any = component?.properties?.config ? component.properties.config : {};
  const selectedTemplate = component?.properties?.config?.template;
  // selectedElementId
  const isFlatListChild = isChildOfFlatList(selectedElementId, components);
  const { selectedRedxTemp } = useSelector((state: any) => state.savedTemplate);
  const {functions} = useSelector((state: any) => state.common);
  const seletedTimeLineTemplate = component?.properties?.styles && component?.properties?.styles[deviceType]?.template
  const { colorPickerContext, dropShadowVisibility, borderVisibility,fontStylesVisibility, backgroundMenuVisibility } = useSelector((state: any) => state.common);
  const {guideVisible, info} = useSelector((state: any) => state.onboarding)
  // const { selectedElementId, deviceType, canvasConfig } = useSelector((state: AppState) => state.formJson);
  const chartTemplate = component?.properties?.config?.template;
  const defaultChartOnload = OnLoadData()
  const [functionsdef, setFunctionsdef] = useState<any>();
  const [ expFunctions, setExpFunctions ] = useState<any>();
  const { type = "" } = component;
  const [timeLineFields, setTimeLineFields]: any = useState({
    label: "",
    title: {},
    subTitle: {},
    description: '',
    descFontColor: "",
    badge:{}
  })
  const [editorContext, setEditorContext] = useState({
    visibility: false,
    source: "",
    where: "",
  });

  const [dropShadowContext, setDropShadowContext] = useState<{
    value: any;
    placeholder?: string;
    where?: string;
    type?: string;
    [key: string]: any;
  }>({
    value: {
      "color": "", "x": "", "blur": "", "y": "", "spread": ""
    },
    placeholder: "",
    where: "",
    type: "",
  });

  let defaultBorderContext = {
    placeholder: "",
    where: "",
    type: "",
    label:"",
    value:{
      color:"",
      stroke:"",
      radius:{
        overAll:0,
        topRight:0,
        bottomRight:0,
        bottomLeft:0,
        topLeft:0
    },
      border:{
          overAll:0,
          top:0,
          right:0,
          bottom:0,
          left:0
      }
    }
}
  const [borderContext,setBorderContext] = useState<IBorderContext>({
    placeholder: "",
    where: "",
    type: "",
    label:"",
    value:{
      color:"",
      stroke:"",
      radius:{
        overAll:0,
        topRight:0,
        bottomRight:0,
        bottomLeft:0,
        topLeft:0
    },
      border:{
          overAll:0,
          top:0,
          right:0,
          bottom:0,
          left:0
      }
    }
})
const [fontStylesContext,setFontStylesContext] = useState<any>({
  placeholder: "",
  where: "",
  type: "",
  label:"",
  category: "",
  value:{
    size:14,
    weight:500,
    color:"",
    alignment:"",
    case:"",
    family:"Inherit",
    decoration:"",
    lineHeight:0,
    letterSpacing:0
  }
})
  const defaultDateRange = {
    startDate: moment(moment(new Date()).set({ hour: 0, minute: 0, second: 0 })).toDate(),
    endDate: moment(moment(new Date()).set({ hour: 23, minute: 59, second: 59 })).toDate(),
    key: 'selection'
  }
  const [fromKeyDateError, setFromKeyDateError] = useState<boolean>(false);
  const [toKeyDateError, setToKeyDateError] = useState<boolean>(false);
  const [fromKeyDateNumberError, setFromKeyDateNumberError] = useState<boolean>(false);
  const [toKeyDateNumberError, setToKeyDateNumberError] = useState<boolean>(false);
  const [showFromKeyError, setShowFromKeyError] = useState<boolean>(false);
  const [showToKeyError, setShowToKeyError] = useState<boolean>(false);
  const [dateRange, setDateRange] = useState<DateRange>(defaultDateRange);

  const { from, selectSpecificDateFrom = "01/01/1800", noOfDaysBeforeToday = 0, noOfMonthsBeforeToday = 0, noOfYearsBeforeToday = 0, end, selectSpecificDateEnd = "31/12/2150", noOfDaysAfterToday = 0, noOfMonthsAfterToday = 0, noOfYearsAfterToday = 0, customDate, dateFormat } = properties;

  const params: any = useParams();
  const version = useSelector(
    (state: any) => state.apps.appVersion[params["appId"]]
  );

  const {type: appType} = useSelector((state: AppState) => state.apps.selectedApp);
  const setEditorVisibility = (visibility: boolean) => {
    setEditorContext((prevState) => ({ ...prevState, visibility }));
  };

  const setHtmlEditorVisibility = (visibility: boolean) => {
    setOpenHtmlandCssEditor((prevState) => ({ ...prevState, visibility }));
  };

  const setColorPickerVisibility = (visibility: boolean) => {
    dispatch(onsetClrPicContext({ ...colorPickerContext, visibility: visibility }))
    // setColorPickerContext((prevState) => ({ ...prevState, visibility }));
  };
  const [originalConfig, setOriginalConfig] = useState<any>({});

  const [openMarkdownEditor, setOpenMarkdownEditor] = useState({
    visibility: false,
    type: "",
    source: "",
    where: "",
  })
  
  const setMarkdownVisibility = (visibility: boolean) => {
    setOpenMarkdownEditor((prevState) => ({ ...prevState, visibility }));
  };
  
  const [configValues, setConfigValues] = useDebouncedAction({}, 500);
  const setDropShadowVisibility = (visibility: boolean) => {
    dispatch(onsetClrPicContext({ ...colorPickerContext, value: "" }))
    dispatch(onsetDropShadowVisibility(visibility))
  }

  const setBorderVisibility = (visibility:boolean) => {
    dispatch(onSetBorderVisibility(visibility))
  }

  const setFontStylesVisibility = (visibility : boolean) =>{
    dispatch(onSetFontStylesVisibility(visibility))
  }

  const setErrorFontStylesVisibility = (visibility : boolean) =>{
    dispatch(onSetErrorFontStylesVisibility(visibility))
  }

  useEffect(()=>{
    setBorderVisibility(false)
    setFontStylesVisibility(false)
    setErrorFontStylesVisibility(false)
  },[])

  const handleChange = (
    path: string,
    value: string | number | boolean | any[]
  ) => {
    let keyList = path.split(".")
    let key: any;
    if(path.includes('wizardStyle')) {
      key = keyList[keyList.length - 2]
    } else {
      key = keyList.pop();
    }
    if (key) {
      myUndoStack.push({
        id: selectedElementId,
        path,
        value: originalConfig[key],
        label: "",
        properties: {},
        fields: [],
        type: "",
      });
      dispatch(
        updateElement({
          id: selectedElementId,
          path,
          value,
        })
      );
      dispatch(
        pushFormActionStack({
          undo: () => {
            const poppedElement = myUndoStack.pop();
            if (poppedElement) {
              myRedoStack.push({ ...poppedElement, value });
              dispatch(
                updateElementOnUndoRedo({
                  id: poppedElement.id,
                  path: poppedElement.path,
                  value: poppedElement.value,
                  increment: -1,
                })
              );
            }
          },
          redo: () => {
            const poppedElement = myRedoStack.pop();
            if (poppedElement) {
              myUndoStack.push({
                ...poppedElement,
                value: originalConfig[`${key}.${keyList[keyList.length - 1]}`],
              });
              dispatch(
                updateElementOnUndoRedo({
                  id: poppedElement.id,
                  path: poppedElement.path,
                  value: poppedElement.value,
                  increment: 1,
                })
              );
            }
          },
        })
      );
      setOriginalConfig(update(originalConfig, { [`${key}.${keyList[keyList.length - 1]}`]: { $set: value } }));
    }
  };

  const handleAddExpansionChange = (_: string, value: string) => {
    const { idx = 0, where, type } = colorPickerContext;
    if (type === "addExpansion") {
      if (component && where) {
        const cellConditions = [...component.properties.config.cellConditions];
        const cellCondition = cellConditions[idx].conditionFields;
        cellCondition[where] = value;
        handleChange(`properties.config.cellConditions`, cellConditions);
      }
    } else if (type === "addExpansion_newSetup") {
      if (where === "background") {
        dispatch(setCondBackground(value));
      } else if (where === "color") {
        dispatch(setCondColor(value));
      }
    } else if (type === "addExtension_TimeLine") {
      // const cellConditions = [...component.properties.config.section];
      if (where === "titleFontColor") {
        if (timeLineFields.length > 0 && idx < timeLineFields.length) {
          const titleColorChange = timeLineFields.map((el: any, id: any) => {
            if (idx === id) {
              const { timeLineFields, key } = el
              return {
                key,
                timeLineFields: {
                  ...timeLineFields,
                  ["title"]: {
                    ...timeLineFields.title,
                    fontColor: value
                  }
                }
              }
            } else {
              return el
            }
          })
          handleChange(`properties.config.section`, titleColorChange);
        } else {
          setTimeLineFields((prevState: any) => {
            return {
              ...prevState,
              title: {
                ...prevState.title,
                fontColor: value
              }
            }
          })
        }
        dispatch(setTitleFontColor(""));
      } else if (where === "subTitleFontColor") {
        if (timeLineFields.length > 0 && idx < timeLineFields.length) {
          const subTitleColor = timeLineFields.map((el: any, id: any) => {
            if (idx === id) {
              const { timeLineFields, key } = el
              return {
                key,
                timeLineFields: {
                  ...timeLineFields,
                  ["subTitle"]: {
                    ...timeLineFields?.subTitle,
                    fontColor: value
                  }
                }
              }
            } else {
              return el
            }
          })
          handleChange(`properties.config.section`, subTitleColor);
        } else {
          setTimeLineFields((prevState: any) => {
            return {
              ...prevState,
              subTitle: {
                ...prevState.subTitle,
                fontColor: value
              }
            }
          })
        }
        dispatch(setSubTitleFontColor(""));
      } else if (where === "descFontColor") {
        if (timeLineFields.length > 0 && idx < timeLineFields.length) {
          const subTitleColor = timeLineFields.map((el: any, id: any) => {
            if (idx === id) {
              const { timeLineFields, key } = el
              return {
                key,
                timeLineFields: {
                  ...timeLineFields,
                  descFontColor: value
                }
              }
            } else {
              return el
            }
          })
          handleChange(`properties.config.section`, subTitleColor);
        } else {
          setTimeLineFields((prevState: any) => {
            return {
              ...prevState,
              descFontColor: value
            }
          })
        }
      }else  if (where === "badgeFontColor") {
        if (timeLineFields.length > 0 && idx < timeLineFields.length) {
          const badgeFontColorChange = timeLineFields.map((el: any, id: any) => {
            if (idx === id) {
              const { timeLineFields, key } = el
              return {
                key,
                timeLineFields: {
                  ...timeLineFields,
                  ["badge"]: {
                    ...timeLineFields.badge,
                    fontColor: value
                  }
                }
              }
            } else {
              return el
            }
          })
          handleChange(`properties.config.section`, badgeFontColorChange);
        } else {
          setTimeLineFields((prevState: any) => {
            return {
              ...prevState,
              badge: {
                ...prevState.badge,
                fontColor: value
              }
            }
          })
        }
        dispatch(setBadgeFontColor(""));
      }
    }
  };

  const renderPanel = (config: Config) => {
    const keys = Object.keys(config);
    const key = keys.find((el: any) => config[el].type === "Custom");
    if (!key) {
      return null;
    }
    const addContent = (content: any) => {
      dispatch(
        updateModalContent({
          type: "SET",
          content,
        })
      );
    };
    const deleteContent = (idx: number) => {
      dispatch(
        updateModalContent({
          type: "DELETE",
          idx,
        })
      );
    };
    const editContent = (content: any, idx: any) => {
      dispatch(
        updateModalContent({
          type: "EDIT",
          content,
          idx,
        })
      );
    };
    const Panel = config[key].panel;
    return (
      <Panel
        getValue={getValue}
        deviceType={deviceType}
        component={component}
        addContent={addContent}
        deleteContent={deleteContent}
        editContent={editContent}
      />
    );
  };
  useEffect(() => {
    const a8Window: any = window;
    const plugin: any = a8Window[type];
    if (plugin && plugin.data) {
      const { config = {} } = plugin.data;
      // only keep the config relavant to this panel
      const sectionConfig = { ...config };
      Object.keys(sectionConfig).forEach((item) => {
        if (sectionConfig[item].section !== section) {
          delete sectionConfig[item];
        }
      });
      setConfig(sectionConfig);
    } else {
      setConfig({});
    }
  }, [selectedElementId, type, section]);

  useEffect(() => {
    if (!selectedElementId) {
      let newConfig: any = {
        onLoad: {
          label: "On load",
          section: "canvas",
          type: Function,
          default: `async function main() {
            // Start of editable area
            
            // End of editable area
          }`,
        },
        onTaskEvent: {
          label: "On Task Event",
          section: "canvas",
          type: Function,
          default: `async function main(event) {
            // Start of editable area
            
            // End of editable area
          }`,
        },
        customExpansion: {
          section: "canvas",
          type: "Expansion",
          label: "",
          default: "",
        },
      };
      setConfig(newConfig);
    }
    if (!canvasConfig.onLoad) {
      dispatch(updateCanvasConfig({
        onLoad: `async function main() {
        // Start of editable area

        // End of editable area
      }`,
      })
      );
    }
  }, [selectedElementId, canvasConfig, dispatch]);

  // Dynamically rendered config props update for undo redo
  const getValueByType = (key: string) => {
    const field = config[key];
    const { key: path, section = [] } = field;
    const where = (path || section) + "." + key;
    const previousValue: string = getValue(
      component,
      where.split("."),
      deviceType
    );
    return previousValue || config[key].value || config[key].default;
  };

  useEffect(() => {
    if (Object.keys(config).length) {
      const values = Object.keys(config).reduce((acc: any, key: any) => {
        acc[key] = getValueByType(key);
        return acc;
      }, {});
      setOriginalConfig(values);
      setConfigValues(values);
    }
    // eslint-disable-next-line
  }, [config])

  var deep_value = function (obj: any, path: any) {
    if (path) {
      // eslint-disable-next-line
      for (var i = 0, path = path.split("."), len = path.length; i < len; i++) {
        obj = obj[path[i]];
      }
      return obj;
    } else {
      return;
    }
  };

  useEffect(() => {
    const a8Window: any = window;
    const plugin: any = a8Window[type];
    if (plugin && plugin.data) {
      const { config = {} } = plugin.data;
      // only keep the config relavant to this panel
      const sectionConfig = { ...config };
      Object.keys(sectionConfig).forEach((item) => {
        if (sectionConfig[item].section !== section) {
          delete sectionConfig[item];
        }
      });
      const values = Object.keys(sectionConfig).reduce((a: any, c: string) => {
        const { key: path, section } = sectionConfig[c];
        const where = (path || section) + "." + c;
        const isCanvas = Object.keys(component).length === 0
        const value = isCanvas
          ? canvasConfig[c]
          : getValue(component, where.split("."), deviceType)
        if (value !== undefined && value !== null) {
          a[c] = value;
        }
        return a;
      }, {});
      setConfigValues(values);
    }    // eslint-disable-next-line
  }, [component]);

  useEffect(() => {
    handleUpdateStartEndDateRanges();
  }, [component?.properties?.config]);
  

  const openCodeEditorModal = async () => {
    let data = await getFunctions(params["appId"], version.versionId);
    setFunctionsdef(data);
  };
  const handleOpenTimeTemplates = () => {
    props.setShowTimelineTemplate(true)
    props.setDeviceType(deviceType)
  }

  const [labelBlur, setLabelBlur] = useState(true);

  async function getFunctionsList() {
    const appId = params[ 'appId' ];
    const versionId = version.versionId;
    Http.get(`/apps/${appId}/functions?versionId=${versionId}`).subscribe((funcRes: any) => {
      if (funcRes && funcRes.length > 0) {
        dispatch(setFunctions(funcRes))
      }
    })
  }

  useEffect(() => {
    if (type === 'VideoKYC') {
      getFunctionsList()
    }
  }, [ type ])

  useEffect(() => {
    if (functions && functions.length > 0) {
      const expFiltered = functions.filter((fuc: any) => fuc.exposeEndpoint === true)
      setExpFunctions(expFiltered)
    }
  }, [ functions ])

  const handleUpdateStartEndDateRanges = () => {
    const parseDate = (dateStr: string) => new Date(Number(dateStr.slice(6, 10)), Number(dateStr.slice(3, 5)) - 1, Number(dateStr.slice(0, 2)));
    const setRange = (startDate: Date | null, endDate: Date | null) => setDateRange({
      startDate: moment(moment(startDate).set({ hour: 0, minute: 0, second: 0 })).toDate(),
      endDate: moment(moment(endDate).set({ hour: 23, minute: 59, second: 59 })).toDate(),
      key: 'selection'
    });

    const handleEndDate = (end: string) => {
      switch (end) {
        case "specificDate":
          return selectSpecificDateEnd ? parseDate(selectSpecificDateEnd) : new Date(2150, 11, 31);
        case "today":
          return new Date();
        case "noOfDaysAfterToday":
          return addDays(new Date(), noOfDaysAfterToday);
        case "noOfMonthsAfterToday":
          return addMonths(new Date(), noOfMonthsAfterToday);
        case "noOfYearsAfterToday":
          return addYears(new Date(), noOfYearsAfterToday);
        default:
          return null;
      }
    };

    const handleStartDate = (from: string) => {
      switch (from) {
        case "specificDate":
          return selectSpecificDateFrom ? parseDate(selectSpecificDateFrom) : new Date(1800, 0, 1);
        case "today":
          return new Date();
        case "noOfDaysBeforeToday":
          return subDays(new Date(), noOfDaysBeforeToday);
        case "noOfMonthsBeforeToday":
          return subMonths(new Date(), noOfMonthsBeforeToday);
        case "noOfYearsBeforeToday":
          return subYears(new Date(), noOfYearsBeforeToday);
        default:
          return null;
      }
    };

    if (customDate) {
      const startDate = handleStartDate(from);
      const endDate = handleEndDate(end);

      if (startDate || endDate) {
        setRange(startDate || new Date(1800, 0, 1), endDate || new Date(2150, 11, 31));
      } else {
        setRange(new Date(1800, 0, 1), new Date(2150, 11, 31));
      }
    }
    else {
      setRange(new Date(1800, 0, 1), new Date(2150, 11, 31));
    }
  }

  useEffect(() => {
    if (toKeyDateError) {
      setShowToKeyError(true);
    } else {
      setShowToKeyError(false);
    }
  }, [toKeyDateError]);

  useEffect(() => {
    if (fromKeyDateError) {
      setShowFromKeyError(true);
    } else {
      setShowFromKeyError(false);
    }
  }, [fromKeyDateError]);

  return (
    <Fragment>
      <div className="space-y-2" >
        {Object.keys(config).map((key) => {
          const isCanvas = Object.keys(component).length === 0;
          const field = config[key];
          const defaultValue = config[key]?.default
          const {
            key: path,
            section,
            placeholder,
            label,
            values = [],
            label1 = "",
            label2 = "",
            placeholder1 = "",
            placeholder2 = "",
            min,
            max,
            title,
            regex = "",
            category
          } = field;
          const where = (path || section) + "." + key;
          const value = isCanvas
            ? canvasConfig[key]
            : getValue(component, where.split("."), deviceType);
          const visibility = getVisibility({...component , deviceType}, field.condition);
          if (!isFlatListChild && flatlistChildLabels.includes(label)) {
            return null;
          }
          // for rendering dropdown list
          // const options = values.map((value: any) => ({ name: value.label, icon: value?.icon }));
          const findStepsCount = component?.properties?.steps
          const findStepperCount = component?.properties?.stepperCount
          const options = values.map((value: any) => ({ name: value.label, icon: value?.icon, selectedIcon: value?.selectedIcon, selectedButtonIcon: value?.selectedButtonIcon }));
          const option: any = values.find((item) => item.value === value) || {};
          const eventLoopOptions = expFunctions?.map((func: any) => ({name: func?.displayName, value: func?.name}))
          const eventLoopOption = expFunctions?.find((evc: any) => evc.name === value)
          const onChange = (value: string | number | boolean) => handleChange(where, value);
          if (!visibility) {
            return null;
          }
          switch (field.type) {
            case "bind": {
              const isFlatListChild = isChildOfFlatList(selectedElementId, components)
              return (
                <Wrapper key={key} className= {"tour_properties_bind"}>
                  <Label id={key} label={label} />
                  <BindInput
                    style={!isCheckedIn ? "not-allowed" : "auto"}
                    disabled={!isCheckedIn}
                    id={key}
                    type="text"
                    value={configValues[key]}
                    placeholder={isFlatListChild ? "$item.key" : placeholder}
                    onChange={(value: string | number) => {
                      const updatedConfig = update(configValues, {
                        [key]: { $set: value },
                      });
                      setConfigValues(updatedConfig, () =>
                        handleChange(where, value)
                      );
                    }}
                  />
                </Wrapper>
              );
            }
            case String: {
              if (field.label !== "Placeholder" && field.label !== "Text") {
                return (
                  <Wrapper key={key} className={`properties_${field.type} ${(field.className && guideVisible) ? field.className : " "}`}>
                    <Label id={key} label={label} />
                    <Input
                      style={!isCheckedIn ? "not-allowed" : "auto"}
                      disabled={!isCheckedIn}
                      id={key}
                      type="text"
                      value={configValues[key]}
                      placeholder={placeholder}
                      regex={regex}
                      onChange={(value: string | number) => {
                        const updatedConfig = update(configValues, {
                          [key]: { $set: value },
                        });
                        setConfigValues(updatedConfig, () =>
                          handleChange(where, value)
                        );
                      }}
                    />
                  </Wrapper>
                );
              } else {
                return (
                  <Wrapper className={`properties_${field.type} ${(field.className && guideVisible) ? field.className : " "}`}>
                    <Label id={key} label={label} />
                    {labelBlur ?
                      <div onClick={() => setLabelBlur(false)}><I18AutoCompletion
                        value={configValues[key]} /></div>
                      :
                      <CustomAutoComplete
                        disabled={!isCheckedIn}
                        value={configValues[key]}
                        defaultValue={configValues[key]}
                        onChange={(e: any) => {
                          const updatedConfig = update(configValues, {
                            [key]: { $set: e },
                          });
                          setConfigValues(updatedConfig, () =>
                            handleChange(where, e)
                          ); console.log(e)
                        }}
                        onSelect={(e: any) => {
                          const updatedConfig = update(configValues, {
                            [key]: { $set: e },
                          });
                          setConfigValues(updatedConfig, () =>
                            handleChange(where, e)
                          );
                        }}
                        onBlur={() => setLabelBlur(true)}
                      />
                    }
                  </Wrapper>
                );
              }
            }
            case "Tags": {
              return (
                <Wrapper key={key}>
                  <Label id={key} label={label} />
                  <div className="panel-input flex items-center justify-start resize-none overflow-hidden whiteSpace-nowrap flex outline-none bg-white max-w-full pr-2 text-sm">
                    <div className="bg-transparent flex flex-row" style={{ gap: "4px", marginLeft: "-2px"}}>
                    {properties && properties.classNameTags && properties.classNameTags.map((val: any, index: any) => (
                        <div key={index} title={val} className="border border-[#e8e8e8] bg-[#fafafa] flex justify-around flex-row rounded rounded-[2px] cursor-default text-[rgba(0,0,0,0.65)]" style={{height: "20px", lineHeight: "20px", width: "79px", padding: "0px 5px", backgroundColor: "#fafafa", alignItems: "center"}} >
                          <div className="w-3/4 text-black truncate">
                            {val}
                          </div>
                          <button className="hover:text-black text-red outline-none"
                            onClick={() => {
                              const updatedTags = properties?.classNameTags.filter((tag: string) => tag !== val);
                              handleChange(where, updatedTags);
                            }}
                          ><span>x</span></button>
                        </div>
                      ))}
                    </div>
                    {value?.length<2 && <input type="text"
                      placeholder={value?.length === 0 ? "Add up to 2 tags" : ""}
                      className="w-full border-none outline-none bg-transparent text-base"
                      style={{paddingLeft: "2px"}}
                      onBlur={(e) => {
                        const tagValue = e.currentTarget.value.trim();
                        if (properties?.classNameTags.includes(tagValue)) {
                          e.currentTarget.value = "";                      
                        }
                        if (properties?.classNameTags.length < 2 && !properties?.classNameTags.includes(tagValue) && tagValue) {
                          const updatedTags = [...properties?.classNameTags, tagValue];
                          e.currentTarget.value = "";
                          handleChange(where, updatedTags);
                        }
                      }}
                      onKeyDown={(e) => {
                        const tagValue = e.currentTarget.value.trim();
                        if (e.key === "Enter" && tagValue) {
                          if (properties?.classNameTags.length < 2 && !properties?.classNameTags.includes(tagValue)) {
                            const updatedTags = [...properties?.classNameTags, tagValue];
                            e.currentTarget.value = "";
                            handleChange(where, updatedTags);
                          }
                        } else if (e.key === "Backspace" && !tagValue) {
                          const updatedTags = properties?.classNameTags.slice(0, -1);
                          handleChange(where, updatedTags);
                        } else if (properties?.classNameTags.length >= 2) {
                          e.preventDefault();
                        }
                      }}
                    />}
                  </div>
                </Wrapper>
              )
            }
            case "divider": {
              return (
                <div style={{ margin: "10px 0px" }} data-test-id={`divider-${type}-${key}`}>
                  <hr />
                </div>
              );
            }
            case "dotted-divider": {
              return (
                <div style={{ borderWidth: "1px", borderStyle: "dashed", borderColor: "rgba(168, 171, 187, 0.4)", margin: "10px 0px" }}></div>
              );
            }
            case "DashedDivider": {
              return(<div style={{borderBottom:"1px dashed rgba(168, 171, 187, 0.4)", margin: "10px 0px"}}></div>)
            }
            case "text": {
              return (
                <Wrapper>
                  <div
                    style={{
                      fontWeight: 700,
                      fontSize: "11px",
                      color: "#282B31",
                      width: "115px",
                    }}
                    data-test-id={`text-${label}`}
                  >
                    {label}
                  </div>
                </Wrapper>
              );
            }
            case "dropDownInput_fixedCol": {
              return <FixedColumn label={label} type={field.type} />;
            }
            case "dropDownInput_colAlign": {
              return (
                <FixedColumn label={label} config={config} type={field.type} />
              );
            }
            case "InputWithOption": {
              return (
                <InputWithOption value={configValues[key]} handleChange={handleChange} where={where} label={label} config={config} field={field}  type={field.type} />
              );
            }
            case "template": {
              return (
                <div className="panel-div" key={selectedRedxTemp?._id || selectedTemplate?._id}>
                  <div className="panel-label">
                    Template
                  </div>
                  <div style={{ height: "28px", width: "170px" }}
                    onClick={() => { type === "Stepper" ? handleOpenTimeTemplates() : props.setShowTemplates(true) }}
                    className="bg-white cursor-pointer flex items-center justify-around border templete_border rounded-sm"
                  >
                    <div style={{ height: "26px", width: "47px" }} className="bg-gray-300 ml-2">
                      <img style={{ height: "100%", width: "100%" }}
                        src={type === "Table" ? selectedTemplate?.icon || TableTemplate1:seletedTimeLineTemplate?._id  ? require(`../../../../../assets/svg/timelineTemplates/${seletedTimeLineTemplate._id}.svg`).default : timelineDefaultTemplate}
                        alt="template"
                      />
                    </div>
                    <div style={{ fontSize: "12px" }} className="font-semibold text-tem_dropdown_text ml-3.5">
                      {selectedTemplate?.label ||
                        selectedRedxTemp?.label ||
                        "Template"}
                    </div>
                    <DropdownIcon className="h-3 w-3 text-gray-400" />
                  </div>
                </div>
              );
            }
            case "AddExpansion": {
              return (
                <AddExpansion
                  type={type}
                  stepperCount={findStepsCount}
                  config={config}
                  timeLineFields={timeLineFields}
                  setTimeLineFields={setTimeLineFields}
                  isCheckedIn={isCheckedIn}
                />
              );
            }
            case "filterExpansion": {
              return (
                <FilterExpansion
                  config={config}
                  isCheckedIn={isCheckedIn}
                />
              );
            }
            case "toggleSwitch": {
              return (
                <ToggleSwitch
                  key={key}
                  id={key}
                  onChange={onChange}
                  value={value}
                  label={label}
                  isCheckedIn={isCheckedIn}
                />
              )
            }
            // case "toggleSwitch": {
            //   return <ToggleSwitch label={label} value={value} onChange={onChange} isCheckedIn={isCheckedIn} />;
            // } 
            case Number: {
              const checkDateRange = (key: string, opValue: Number, dateRange: DateRange, setFromKeyDateNumberError: (val: boolean) => void, setToKeyDateNumberError: (val: boolean) => void) => {
                const { startDate, endDate } = dateRange;
                if (!startDate || !endDate) return;
              
                const operations: any = {
                  noOfDaysBeforeToday: subDays,
                  noOfMonthsBeforeToday: subMonths,
                  noOfYearsBeforeToday: subYears,
                  noOfDaysAfterToday: addDays,
                  noOfMonthsAfterToday: addMonths,
                  noOfYearsAfterToday: addYears,
                };
              
                const isBeforeToday = key.includes("Before");
                const resultDate = operations[key](new Date(), Number(opValue));
              
                isBeforeToday && setFromKeyDateNumberError(resultDate > endDate);
                !isBeforeToday && setToKeyDateNumberError(resultDate < startDate);
              };

              return (
                <Wrapper key={key}>
                  <Label id={key} label={label} />
                  <div data-test-id={key}>
                    <Input
                      style={!isCheckedIn ? "not-allowed" : "auto"}
                      disabled={!isCheckedIn}
                      id={key}
                      min={min ? min : undefined}
                      max={max ? max : undefined}
                      type="number"
                      value={configValues[key] || value}
                      placeholder={placeholder}
                      onChange={(val) => {
                        type === "DateRangePicker" && checkDateRange(key, Number(val), dateRange, setFromKeyDateNumberError, setToKeyDateNumberError);
                        onChange(val);
                      }}
                    />
                    <div>
                      {toKeyDateNumberError && (
                        <p data-test-id="validation_error_message" className="error_message__date_picker">
                          Select on/after from date.
                        </p>
                      )}
                      {fromKeyDateNumberError && (
                        <p data-test-id="validation_error_message" className="error_message__date_picker">
                          Select on/before end date.
                        </p>
                      )}
                    </div>
                  </div>
                </Wrapper>
              );
            }
            case Boolean: {
              return (
                <Checkbox
                  disabled={!isCheckedIn}
                  key={key}
                  id={key}
                  type={type}
                  value={value}
                  label={label}
                  onChange={onChange}
                />
              );
            }
            case Array: {
              return (
                <Wrapper key={key} className={`${(field.className && guideVisible) ? field.className : " "}`} testId={`Array-${type}-${key}`}>
                  {label && <Label id={key} label={label} />}
                  <div data-test-id={key}>
                    <Dropdown
                      type={type}
                      label={label}
                      cursorStyle={!isCheckedIn ? "not-allowed" : "auto"}
                      disabled={!isCheckedIn}
                      options={options}
                      selected={{ name: option.label }}
                      defaultValue={field.default}
                      onChange={(opt) => {
                        let opValue = opt.name;
                        if (type === "DateRangePicker" && dateRange.startDate && dateRange.endDate) {
                          const isToday = opValue === "Today";
                          if (key === "from") {
                            if (isToday && moment(moment(new Date()).set({ hour: 0, minute: 0, second: 0 })).toDate() > moment(moment(dateRange.endDate).set({ hour: 0, minute: 0, second: 1 })).toDate()) {
                              setFromKeyDateError(true);
                            } else {
                              setFromKeyDateError(false);
                              if (end === "today" && toKeyDateError) {
                                setToKeyDateError(false);
                              }
                            }
                          } else if (key === "end") {
                            if (isToday && moment(moment(new Date()).set({ hour: 0, minute: 0, second: 1 })).toDate() < moment(moment(dateRange.startDate).set({ hour: 0, minute: 0, second: 0 })).toDate()) {
                              setToKeyDateError(true);
                            } else {
                              setToKeyDateError(false);
                              if (from === "today" && fromKeyDateError) {
                                setFromKeyDateError(false);
                              }
                            }
                          }
                        }

                        if (field.values) {
                          const item = field.values.find(
                            (item) => item.label === opValue
                          );
                          if (item) {
                            handleChange(where, item.value);
                          }
                        }
                      }}
                    />
                    <div>
                      {showToKeyError && key === "end" && (
                        <p data-test-id="validation_error_message" className="error_message__date_picker">
                          Select on/after from date.
                        </p>
                      )}
                      {showFromKeyError && key === "from" && (
                        <p data-test-id="validation_error_message" className="error_message__date_picker">
                          Select on/before end date.
                        </p>
                      )}
                    </div>
                  </div>
                </Wrapper>
              );
            }
            case "EventCallback": {
              return (
                <Wrapper key={key} className={`${(field.className && guideVisible) ? field.className : " "}`}>
                  {label && <Label id={key} label={label} />}
                  <Dropdown
                    cursorStyle={!isCheckedIn ? "not-allowed" : "auto"}
                    disabled={!isCheckedIn}
                    options={eventLoopOptions || []}
                    selected={{ name: eventLoopOption?.name }}
                    placeholder="Select callback event"
                    onChange={(option) => {
                      if (expFunctions) {
                        const item = expFunctions?.find(
                          (item: any) => item.name === option?.value
                        );
                        if (item) {
                          handleChange(where, item?.name);
                        }
                      }
                    }}
                  />
                </Wrapper>
              );
            }
            case "TopRightBottomLeft": {
              return (
                <TopRightBottomLeft
                  custom={true}
                  disabled={!props.isCheckedIn}
                  style={!isCheckedIn ? "not-allowed" : "auto"}
                  id={where}
                  label={field.label}
                  value={{
                    overall: properties && properties[key]?.overall,
                    top: properties && properties[key]?.top,
                    right: properties && properties[key]?.right,
                    bottom: properties && properties[key]?.bottom,
                    left: properties && properties[key]?.left,
                  }}
                  onChange={(key: string, value: string) => {
                    handleChange(key, value);
                  }}
                />
              );
            }
            case Function: {
              return (
                <Wrapper key={key}>
                  <p className="panel-label">
                    {label}
                  </p>
                  <p
                    className="flex items-center font-medium rounded-md cursor-pointer tour_function_panel"
                    style={{
                      color: "#0466C8",
                      backgroundColor: "rgba(4, 102, 200, 0.1)",
                      height: "28px",
                      width: "170px",
                      padding: "5px"
                    }}
                    onClick={async () => {
                      setColorPickerVisibility(false);
                      await openCodeEditorModal();
                      setEditorContext({
                        visibility: true,
                        source: value ? value : field.default,
                        where,
                      });
                      if (guideVisible) {
                        setTimeout(() => dispatch(setStepIndex(info.stepIndex + 1)), 300)
                      }
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%"
                      }}
                    >
                      <span>{key === "onClick" ? "On click" : key === "onChange" ? "On change" : "On load"}</span>
                      <img src={EditorIcon} alt="editorIcon" />
                    </div>
                  </p>
                </Wrapper>
              );
            }
            case "Divider": {
              return (
                <div style={{ margin: "10px 0px" }}>
                  <hr />
                </div>
              )
            }
            case "Label": {
              return (
                <div style={{ color: "#282B31", fontSize: "11px", fontWeight: 700, marginTop: 10 }}>
                  {label}
                </div>
              )
            }
            case "htmlCodeEditor": {
              return (
                <Wrapper key={key} >
                  <p style={{ color: "#282B31", fontSize: 11 }} className="block font-semibold py-1">{label}</p>
                  <p
                    className="col-span-2 font-medium rounded-md cursor-pointer"
                    style={{
                      color: "#0466C8",
                      backgroundColor: "rgba(4, 102, 200, 0.1)",
                      height: "28px", width: "170px", padding: "5px"
                    }}
                    onClick={async () => {
                      setColorPickerVisibility(false)
                      await openCodeEditorModal();
                      setOpenHtmlandCssEditor({
                        visibility: true,
                        type: "html",
                        source: value ? value : field.default,
                        where,
                      });
                    }}
                  >
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      {key === "onClick" ? "On click" : "HTML editor"}
                      <img src={EditorIcon} alt="editorIcon" />
                    </div>
                  </p>
                </Wrapper>
              )
            }
            case "cssCodeEditor": {
              return (
                <Wrapper key={key} >
                  <p style={{ color: "#282B31", fontSize: 11 }} className="block font-semibold py-1">{label}</p>
                  <p
                    className="col-span-2 font-medium rounded-md cursor-pointer"
                    style={{
                      color: "#0466C8",
                      backgroundColor: "rgba(4, 102, 200, 0.1)",
                      height: "28px", width: "170px", padding: "5px"
                    }}
                    onClick={async () => {
                      setColorPickerVisibility(false)
                      await openCodeEditorModal();
                      setOpenHtmlandCssEditor({
                        visibility: true,
                        type: "css",
                        source: value ? value : field.default,
                        where,
                      });
                    }}
                  >
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      {key === "onClick" ? "On click" : "CSS editor"}
                      <img src={EditorIcon} alt="editorIcon" />
                    </div>
                  </p>
                </Wrapper>
              )
            }
            case "ReviewShape": {
              return (
                <Wrapper key={key}>
                  <Label id={key} label={label} />
                  <RatingShape
                    cursorStyle={!isCheckedIn ? "not-allowed" : "auto"}
                    disabled={!isCheckedIn}
                    options={options}
                    selected={{ name: option.label, icon: option.selectedButtonIcon }}
                    onChange={(option) => {
                      if (field.values) {
                        const item = field.values.find(
                          (item) => item.label === option.name
                        );
                        if (item) {
                          handleChange(where, item.value);
                        }
                      }
                    }}
                  />
                </Wrapper>
              );
            }

            case "TabBar": {
               return (
                <div className="grid grid-cols-3 items-center justify-between" style={{marginTop: "10px", gap: 35}}>
                  {title && <Label id={key} label={title} />}
                  <div className={title ? "relative col-span-2 ml-1" : "relative col-span-3"}>
                    <Tab.Group >
                      <Tab.List className="flex items-center" style={{ border: "1px solid rgba(125, 132, 146, 0.27)", background: "rgba(125, 132, 146, 0.1)", borderRadius: "2px", maxWidth: title&&"170px", height: "28px" }}>
                        {
                          field.tabList && field.tabList.map((tab: any, index: any) => {
                            return (
                              <Tab as={Fragment}>
                                {({ selected }) => (
                                  <button
                                    onClick={() => {
                                      const updatedConfig = update(configValues, {
                                        [key]: { $set: tab.value }
                                      });
                                      setConfigValues(updatedConfig, () => handleChange(where, tab.value));
                                    }}
                                    style={properties[key] === tab.value ? {
                                      background: "#052f35 ",
                                      color: "white",
                                      borderRadius: "2px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      height: "24px",
                                      margin: "1px"
                                    }
                                      : {
                                        background: "none",
                                        color: "#052f35 ",
                                        borderRadius: "2px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        transition: "background 0.2s ease, color 0.2s ease",
                                        height: "24px",
                                        margin: "1px"
                                      }}
                                    className="w-full focus:outline-none"
                                  >
                                    {tab?.selectedIcon && tab?.unSelectedIcon ? properties[key] === tab.value ? tab.selectedIcon() : tab.unSelectedIcon() : tab.label}
                                  </button>
                                )}
                              </Tab>
                            )
                          })
                        }
                      </Tab.List>
                    </Tab.Group>
                  </div>
                </div>
              )
            }
            case "DoubleInput": {
              const where1 =
                (path || section) + "." + key + label1.toLowerCase();
              const where2 =
                (path || section) + "." + key + label2.toLowerCase();
              var value1 = isCanvas
                ? canvasConfig[key]
                : getValue(component, where1.split("."), deviceType);
              var value2 = isCanvas
                ? canvasConfig[key]
                : getValue(component, where2.split("."), deviceType);
              const onChange1 = (value: string | number | boolean) => {
                handleChange(where1, value);
              };
              const onChange2 = (value: string | number | boolean) => {
                handleChange(where2, value);
              };
              return (
                <>
                  <div style={{ marginTop: "10px", display: "flex", flexDirection: "column", justifyContent: "space-between", gap: "10px", width: "100%" }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                      <div
                        style={{ display: "flex", alignItems: "center", justifyContent: "Center", fontSize: "11px", color: "#282B31", marginRight: "12px", lineHeight: "14px" }}
                        className="text-gray-900 dark:text-gray-300 font-semibold"
                      >
                        {label1==="W"?"Width":label1==="H"?"Height":label1}
                      </div>
                      <Input
                        style={!isCheckedIn ? "not-allowed" : "auto"}
                        disabled={!isCheckedIn}
                        id={key}
                        type="number"
                        placeholder={placeholder1}
                        value={value1 || ""}
                        onChange={onChange1}
                        width="170px"
                      />
                    </div>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                      <div
                        style={{ display: "flex", alignItems: "center", justifyContent: "Center", fontSize: "11px", color: "#282B31", marginRight: "12px", lineHeight: "14px" }}
                        className="text-gray-900 dark:text-gray-300 font-semibold"
                      >
                        {label2==="W"?"Width":label2==="H"?"Height":label2}
                      </div>
                      <Input
                        style={!isCheckedIn ? "not-allowed" : "auto"}
                        disabled={!isCheckedIn}
                        id={key}
                        placeholder={placeholder2}
                        type="number"
                        value={value2 || ""}
                        onChange={onChange2}
                        width="170px"
                      />
                    </div>
                  </div>
                </>
              );
            }
            case "ColorPicker": {
              return (
                <ColorPicker
                  key={key}
                  pickerkey={key}
                  label={label}
                  value={value}
                  open={() => {
                    dispatch(onsetClrPicContext({
                      value: value,
                      placeholder: placeholder || "",
                      where: where,
                      visibility: true,
                    }))
                    dispatch(onsetDropShadowVisibility(false))
                    dispatch(onSetBorderVisibility(false))
                    dispatch(onSetFontStylesVisibility(false))
                    dispatch(onSetTextEditorVisibility(false))
                  }}
                  visibility={colorPickerContext?.visibility}
                  close={()=>setColorPickerVisibility(false)}
                />
              );
            }
            case "DropShadow": {
              return (
                <DropShadow
                  key={key}
                  label={label}
                  value={value}
                  placeholder={placeholder}
                  open={() => {
                    setDropShadowContext({
                      value,
                      placeholder: placeholder || "",
                      where,
                    });
                    dispatch(onsetClrPicContext({
                      value: value?.color,
                      placeholder: "",
                      where: where,
                      visibility: false,
                    }))
                    dispatch(onsetDropShadowVisibility(true))
                    dispatch(onSetBorderVisibility(false))
                    dispatch(onSetFontStylesVisibility(false))
                    dispatch(onSetTextEditorVisibility(false))
                  }}
                  visible={dropShadowVisibility}
                />
              )
            }

            case "InputWithIcon": {
              return (

                <Wrapper key={key}>
                  <div
                    className="flex items-center justify-start"
                    key={key}
                    id={key}
                  >
                    <Label id={key} label={label} />
                    <Popover content={<div style={{ fontSize: "12px" }}><div>Sets the space between the margin and</div><div> the QR Code on all sides</div></div>} >
                      <IIcon style={{marginLeft: "-50px"}}/>
                    </Popover>
                  </div>
                  <Input
                    style={!isCheckedIn ? "not-allowed" : "auto"}
                    disabled={!isCheckedIn}
                    id={key}
                    min={min ? min : undefined}
                    max={max ? max : undefined}
                    type="number"
                    value={configValues[key] || value}
                    placeholder={placeholder}
                    onChange={onChange}
                  />
                </Wrapper>

              );
            }
            case "TopRightBottomLeft": {
              return (
                <TopRightBottomLeft
                  custom={true}
                  disabled={!props.isCheckedIn}
                  id={where}
                  label={field.label}
                  value={{
                    overall: properties && properties[key]?.overall,
                    top: properties && properties[key]?.top,
                    right: properties && properties[key]?.right,
                    bottom: properties && properties[key]?.bottom,
                    left: properties && properties[key]?.left,
                  }}
                  onChange={(key: string, value: string) => {
                    handleChange(key, value)
                  }}
                />
              )
            }
            case "Divider": {
              return (
                <div>
                  <hr />
                </div>
              )
            }
            case "ReviewShape": {
              return (
                <Wrapper key={key}>
                  <Label id={key} label={label} />
                  <RatingShape
                    cursorStyle={!isCheckedIn ? "not-allowed" : "auto"}
                    disabled={!isCheckedIn}
                    options={options}
                    selected={{ name: option.label, icon: option.icon }}
                    defaultSelected={defaultValue}
                    onChange={(option) => {
                      if (field.values) {
                        const item = field.values.find(
                          (item) => item.label === option.name
                        );
                        if (item) {
                          handleChange(where, item.value);
                        }
                      }
                    }}
                  />
                </Wrapper>)
            }
            case "AddExpansion": {
              return (
                <AddExpansion config={config} isCheckedIn={isCheckedIn}></AddExpansion>
              )
            }
            case "textEditor": {
              return (
                <TextEditorPopper value={configValues[key]} handleChange={handleChange} where={where} field={field} isCheckedIn={isCheckedIn}></TextEditorPopper>
              )
            }
            case "FontStyles": {
              return (
                <FontStyles
                  key={key}
                  label={label}
                  value={value}
                  placeholder={placeholder}
                  type={type}
                  open={() => {
                    setFontStylesContext({
                      value,
                      placeholder: placeholder || "",
                      where,
                      label,
                      category
                    });
                    dispatch(onsetClrPicContext({
                      value: value?.color,
                      placeholder: "",
                      where: where,
                      visibility: false,
                    }))
                    dispatch(onSetBorderVisibility(false))
                    dispatch(onSetFontStylesVisibility(true))
                    dispatch(onSetTextEditorVisibility(false))
                  }}
                >
                </FontStyles>
              )
            }
            case "Border": {
              return (
                <Border
                  key={key}
                  label={label}
                  value={value}
                  type={type}
                  placeholder={placeholder}
                  open={() => {
                      setBorderContext({
                        value: value ?  value : defaultBorderContext.value,
                        placeholder: placeholder || "",
                        where,
                        label
                      });
                    dispatch(onsetClrPicContext({
                      value: value?.color,
                      placeholder: "",
                      where: where,
                      visibility: false,
                    }))
                    dispatch(onSetBorderVisibility(true))
                    dispatch(onSetFontStylesVisibility(false))
                    dispatch(onSetTextEditorVisibility(false))
                  }}
                >
                </Border>
              )
            }
            // Custom fonts is available in static assets
            // case "Expansion":
            //   return(
            //     <FontFamilyExpansion
            //     onChange={
            //       colorPickerContext?.type === "addExpansion" ||
            //         colorPickerContext?.type === "addExpansion_newSetup" ||
            //         colorPickerContext?.type === "addExtension_TimeLine"
            //         ? handleAddExpansionChange
            //         : handleChange
            //     }
            //     />
            //   )
            case "MarkdownEditor": {
              return (
                <Wrapper key={key} >
                  <div style={{display: "flex", flexDirection: "column", justifyContent: "start", width: "100%"}}>
                  <p style={{ color: "#282B31", fontSize: 11 }} className="block font-semibold">{label}</p>
                  <p
                    className="col-span-2 font-medium rounded-md cursor-pointer "
                    style={{
                      color: "#0466C8",
                      backgroundColor: "rgba(4, 102, 200, 0.1)",
                      height: "28px", width: "100%", marginTop: "10px", padding: "5px"
                    }}
                    onClick={async () => {
                      await openCodeEditorModal();
                      setOpenMarkdownEditor({
                        visibility: true,
                        type: "markdown",
                        source: value ? value : field?.default,
                        where,
                      });
                    }}
                  >
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      {key === "onClick" ? "On click" : "Markdown editor"}
                      <img src={MarkDownIcon} alt="markdown" />
                    </div>
                  </p>
                  </div>
                </Wrapper>
              )
            }
            case "WizardStyle": {
              return (
                <WizardStyle
                  key={key}
                  label={label}
                  value={value}
                  open={(path: string) => {
                    dispatch(onsetClrPicContext({
                      value: value,
                      placeholder: placeholder || "",
                      where: `properties.styles.$deviceType.wizardStyle.${path}`,
                      visibility: true,
                    }))
                    dispatch(onsetDropShadowVisibility(false))
                    dispatch(onSetBorderVisibility(false))
                    dispatch(onSetFontStylesVisibility(false))
                    dispatch(onSetTextEditorVisibility(false))
                  }}
                />
              )
            }
            case "backgroundImage": {
              return (
                <>
                  <ApplyBackgroundImage
                    open={() => {
                      dispatch(onSetBgdMenuVisibility(true));
                    }}
                    label={"Icon"}
                    menuVisibility={backgroundMenuVisibility}
                  />
                  {backgroundMenuVisibility ? (
                    <BackgroundImageMenu
                      type={component.type}
                      from="Layout"
                      where="$deviceType.backgroundImage"
                      close={() => dispatch(onSetBgdMenuVisibility(false))}
                      isCheckedIn={props.isCheckedIn}
                    />
                  ) : null}
                  </>
              );
              break; 
            }
            case "chartTemplate": {
              return (
                <Wrapper key={key}>
                  {label && <Label id={key} label={label} />}
                  <ChartTemplate
                    cursorStyle={!isCheckedIn ? "not-allowed" : "auto"}
                    disabled={!isCheckedIn}
                    options={options}
                    selected={{ name: option.label }}
                    defaultValue={field.default}
                    onChange={(option) => {
                      if (field.values) {
                        const item = field.values.find(
                          (item) => item.label === option.name
                        );
                        if (item) {
                          const chartTemplate:any = item?.value;
                          const chartTemplateMap:any = {
                            basicBar: defaultChartOnload.onLoad,
                            barBackground: defaultChartOnload.onLoad2,
                            axisAlign: defaultChartOnload.onLoad3,
                            singleBar: defaultChartOnload.onLoad4,
                            waterfall: defaultChartOnload.onLoad5,
                            negativeValueBar: defaultChartOnload.onLoad6,
                            barRace: defaultChartOnload.onLoad7,
                            basicLine: defaultChartOnload.onLoad8,
                            stackedLine : defaultChartOnload.onLoad9
                          };
                          const selectedOnLoad = chartTemplateMap[chartTemplate] || defaultChartOnload.onLoad;
                          handleChange(where, item.value);
                          handleChange(`properties.config.onLoad`, selectedOnLoad)
                        }
                      }
                    }}
                  />
                </Wrapper>
              )
            }
            case "datePicker": {
              return (
                <Wrapper key={key}>
                  {label && <Label id={key} label={label} />}
                  <DatePickerPropertyPanel
                    value={value}
                    keyVal={key}
                    setConfigValues={setConfigValues}
                    dateRange={dateRange}
                    configValues={configValues}
                    handleChange={handleChange}
                    where={where}
                    setFromKeyDateErrorVal={setFromKeyDateError}
                    setToKeyDateErrorVal={setToKeyDateError}
                    setFromKeyDateNumberErrorVal={setFromKeyDateNumberError}
                    setToKeyDateNumberErrorVal={setToKeyDateNumberError}
                  />
                </Wrapper>
              )
            }
            default: {
              return null;
            }
          }
        })}
      </div >
      {renderPanel(config)}
      {
        editorContext.visibility ? (
          <EditorPanel
            customdef={functionsdef}
            isCheckedIn={isCheckedIn}
            close={() => setEditorVisibility(false)}
            editorContext={editorContext}
            type={"inline"}
          />
        ) : null
      }
      {
        openHtmlandCssEditor.visibility ? (
          <HtmlandCssEditor
            onChange={(option: any) => {
              handleChange(openHtmlandCssEditor.where, option);
            }
            }
            customdef={functionsdef}
            isCheckedIn={isCheckedIn}
            close={() => setHtmlEditorVisibility(false)}
            editorContext={openHtmlandCssEditor}
          />
        ) : null
      }
      {colorPickerContext?.visibility ? (
        <ColorPickerMenu
          type={type}
          isCheckedIn={isCheckedIn}
          close={() => setColorPickerVisibility(false)}
          onChange={
            colorPickerContext?.type === "addExpansion" ||
              colorPickerContext?.type === "addExpansion_newSetup" ||
              colorPickerContext?.type === "addExtension_TimeLine"
              ? handleAddExpansionChange
              : handleChange
          }
        />
      ) : null}
      {dropShadowVisibility ? (
        <DropShadowMenu
          isCheckedIn={isCheckedIn}
          close={() => {
            setDropShadowVisibility(false);
            setColorPickerVisibility(false)
          }}
          dropShadowContext={dropShadowContext}
          onChange={handleChange}
          setDropShadowContext={setDropShadowContext}
          open={() => {
            dispatch(onsetClrPicContext({
              value: colorPickerContext?.value,
              placeholder: "eg: #000000",
              where: "",
              visibility: true,
            }))
          }}
        />
      ) : null
      }
      {fontStylesVisibility ? 
        <FontStylesPopper
          component={component}
          isCheckedIn={isCheckedIn}
          close={() => {
            setDropShadowVisibility(false);
            setColorPickerVisibility(false)
            setBorderVisibility(false)
            setFontStylesVisibility(false)
            setErrorFontStylesVisibility(false)
          }}
          onChange={handleChange}
          fontStylesContext={fontStylesContext}
          setFontStylesContext={setFontStylesContext}
          open={() => {
            dispatch(onsetClrPicContext({
              value: colorPickerContext?.value,
              placeholder: "eg: #000000",
              where: "",
              visibility: true,
            }))
          }}
        >
        </FontStylesPopper> : null
      }

      {borderVisibility ? (
        <BorderPopper
          isCheckedIn={isCheckedIn}
          close={() => {
            setDropShadowVisibility(false);
            setColorPickerVisibility(false)
            setBorderVisibility(false)
          }}
          onChange={handleChange}
          borderContext={borderContext}
          setBorderContext={setBorderContext}
          open={() => {
            dispatch(onsetClrPicContext({
              value: colorPickerContext?.value,
              placeholder: "eg: #000000",
              where: "",
              visibility: true,
            }))
          }}
        />
      ) : null}
      {openMarkdownEditor?.visibility ? (
          <MarkdownEditor
            onChange={(option: any) => {
              handleChange(openMarkdownEditor?.where, option);
            }}
            customdef={functionsdef}
            isCheckedIn={isCheckedIn}
            close={() => setMarkdownVisibility(false)}
            editorContext={openMarkdownEditor}
          />
        ) : null}
    </Fragment>
  );
};
/* helper components for rendering config */


interface IRatingShape {
  options: { name: string, icon: any, selectedButtonIcon?: any, selectedIcon?:any }[];
  selected: { name: string, icon: any };
  onChange: (option: { name: string, value?: string, icon?: any }) => void;
  disabled?: boolean;
  cursorStyle?: any;
  defaultSelected?: any
}
export const RatingShape: React.FC<IRatingShape> = ({
  options,
  selected,
  onChange,
  disabled,
  cursorStyle,
  defaultSelected
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  return (
    <div style={{ borderRadius: "2px", width:"170px", height:"28px", border: !isOpen ?"1px solid #7D84924B":"" }}
      className="relative col-span-1 bg-white text-gray-900 text-lg">
      <Listbox disabled={disabled} value={selected} onChange={onChange}>
        {({ open }) => {
          setIsOpen(open)
          return (
            <>
              <Listbox.Button className={`relative flex items-center h-full w-full text-lx cursor-pointer bg-white text-left focus:outline-none ${open ? "corePropertiesDropDown" : ""}`} style={{padding: "10px 5px"}}>
                <div className="flex items-center">
                  <span className="flex">
                    {selected && selected.icon && selected.icon() }</span>
                  <span className="pt-0 font-semibold overflow-hidden overflow-ellipsis whitespace-nowrap truncate" style={{ width: "120px", fontSize: "12px", lineHeight: "normal", color: "#292D32", marginLeft: "10px" }}>{selected.name}</span>
                  <span style={{paddingRight:"5px"}} className="pointer-events-none absolute inset-y-0 right-0 flex items-center">
                   <DropdownIcon className="h-3 w-3 text-gray-400" />
                  </span></div>
              </Listbox.Button>
              <Transition
                as={Fragment}
                leave="transition ease-in duration-100"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Listbox.Options style={{ marginTop: "5px", border: "1px solid rgba(125, 132, 146, 0.294)", boxShadow: "0px 5px 8px rgba(125, 132, 146, 0.11)", borderRadius: "4px", width: "170px", maxHeight:"175px" }} 
                className="absolute w-full overflow-y-scroll rounded-t bg-white text-base ring-1 ring-black ring-opacity-5 focus:outline-none z-40 cursor-pointer">
                  {options.map((type, colorIdx) => (
                    <Listbox.Option
                      key={colorIdx}
                      style={{ fontSize: "11px", fontWeight: 600, lineHeight: "14px", margin: "10px" }}
                      className={({ active }) => {
                        return `relative cursor-pointer flex items-center truncate select-none ${active ? "text-selectedText_color" : "text-unselectedText_color"}`
                      }
                      }
                      value={type}
                    >
                      {({ active }) => (
                        <div className="flex items-center" style={{width:"157px"}}>
                          <span
                            className={`block truncate font-medium w-7`}>
                            {active || selected.name===type.name ? type.selectedIcon && type.selectedIcon() : type.icon()}
                          </span>
                          <span
                            style={{ fontSize:"11px",marginLeft:"5px" }}
                            className={`block truncate font-semibold items-center ${active ? "hover:text-selectedText_color" : ""} ${selected.name === type.name ? 'text-selectedText_color' : "text-unselectedText_color"}`}>
                            {type.name}
                          </span>
                        </div>
                      )}
                    </Listbox.Option>
                  ))}
                </Listbox.Options>
              </Transition>
            </>
          )
        }}
      </Listbox>
    </div>
  );
};

interface ILabel {
  label: string;
  id: string;
}
export const Label: React.FC<ILabel> = ({ label, id }) => {
  return (
    <label
      htmlFor={id}
      className="panel-label"
    >
      {label}
    </label>
  );
};
interface IInput {
  type: "text" | "number";
  id: string;
  value: string;
  placeholder?: string;
  onChange: (value: string | number) => void;
  disabled?: boolean;
  style?: any;
  min?: string;
  max?: string;
  width?: string
  regex?: string;
  components?:any
}

export const Input: React.FC<IInput> = ({
  type,
  id,
  value,
  placeholder,
  onChange,
  disabled,
  style,
  min,
  max,
  width = "",
  regex,
}) => {
  return (
    <input
      disabled={disabled}
      type={type}
      id={id}
      min = {type === "number" ? "0" : ""}
      value={value}
      defaultValue={0}
      className="panel-input"
      placeholder={placeholder}
      onChange={(e) => {
        const changeValue = e.target.value;
        const value = changeValue && type === "number" ? Number(changeValue) > 0 ? changeValue : "0": changeValue;
        if (id === "bind") {
          regex = "^[$a-zA-Z_]+[{}_a-zA-Z0-9_]*$"
        }
        if (min && max && type === "number") {
          if (value === "") {
            onChange(value);
          } else {
            if (value >= min && value <= max) {
              onChange(value);
            }
          }
        } else {
          if (regex && typeof (value) === "string" && value.length != 0 && !value.match(regex)) {
            return
          }
          onChange(value);
        }
      }}

    />
  );
};
export const BindInput: React.FC<IInput> = ({
  type,
  id,
  value,
  placeholder,
  onChange,
  disabled,
  style,
  min,
  max,
  width = "",
  regex,
}) => {
  return (
    <input
      disabled={disabled}
      type={type}
      id={id}
      value={value}
      className="panel-input"
      placeholder={placeholder}
      onChange={(e) => {
        const changeValue = e.target.value;
        const format = /[ `!@#%^&*()_+\-=\[\];':"\\|,<>\/?~]/
        if (!(format.test(changeValue))) {
          const value = changeValue && changeValue;
          onChange(value);
        }
      }}
    />
  );
};
interface IDropdown {
  options: { name: string }[];
  selected: { name: string };
  onChange: (option: { name: string; value?: string }) => void;
  disabled?: boolean;
  cursorStyle?: any;
  defaultValue?: any;
  placeholder?: string;
  type?: string;
  label?: string;
}
export const Dropdown: React.FC<IDropdown> = ({
  type,
  label,
  options,
  selected,
  onChange,
  disabled,
  cursorStyle,
  defaultValue,
  placeholder
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  return (
    <div
      style={{ borderRadius: "2px" ,width: "170px", height: "28px", border: !isOpen ?"1px solid #7D84924B":"" }}
      className={`relative col-span-1 ${!isOpen ? "bg-white" : ""} text-gray-900 text-lg `}
    >
      <Listbox disabled={disabled} value={selected} onChange={onChange}>
        {({ open }) => {
          setIsOpen(open)
          return (
            <>
              <Listbox.Button className={`relative flex items-center h-full w-full text-lx cursor-pointer bg-white text-left focus:outline-none ${open ? "corePropertiesDropDown" : ""}`} style={{padding: "10px 5px"}}>
              {selected.name?<span style={{ width: "92%", color: "#292D32", lineHeight: "normal", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", fontSize: "12px", fontWeight: 500 }}>
                  {selected.name || defaultValue}
                </span>:
                <span style={{fontSize:"12px", color: "#969BA5"}}>{placeholder || null}</span>}
                <span style={{height: "28px"}} className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                  <DropdownIcon className="h-3 w-3 text-gray-400" />
                </span>
              </Listbox.Button>
              <Transition
                as={Fragment}
                leave="transition ease-in duration-100"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Listbox.Options data-test-id={`dropdown_options-${type}-${label}`} style={{ marginTop: "5px", border: "1px solid rgba(125, 132, 146, 0.294)", boxShadow: "0px 5px 8px rgba(125, 132, 146, 0.11)", borderRadius: "4px", maxHeight: "175px", paddingBottom: "10px" }} className="absolute w-full overflow-auto rounded bg-white text-base focus:outline-none z-40 cursor-pointer">
                  {options.length?options.map((type, colorIdx) => (
                    <Listbox.Option
                      key={colorIdx}
                      style={{ fontSize: "11px", fontWeight: 600, margin: "10px 10px 0px 10px" }}
                      className="relative cursor-pointer select-none"
                      value={type}
                    >
                      {({ active }) => {
                        return (
                          <span
                            style={{ fontSize: selected ? "12px" : "11px", lineHeight: "normal" }}
                            data-test-id={type.name}
                            className={`block truncate ${active ? "hover:text-selectedText_color" : ""} font-medium ${selected.name === type.name ? 'text-selectedText_color' : "text-unselectedText_color"}`}
                          >
                            {type.name}
                          </span>
                        )
                      }}
                    </Listbox.Option>
                  )):<div className="flex items-center justify-center" style={{padding: "10px", marginTop: "10px"}}><NoData height={50}/></div>}
                </Listbox.Options>
              </Transition>
            </>
          )
        }}
      </Listbox>
    </div >
  );
};
interface ICheckbox {
  id: string;
  value: boolean;
  label: string;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  type?: string;
}
const Checkbox: React.FC<ICheckbox> = ({
  disabled,
  id,
  value,
  label,
  onChange,
  type,
}) => {
  return (
    <div className="panel-div">
      <div className="panel-label"></div>
      <div className="flex items-center" style={{ width: "170px" }} data-test-id={`checkbox-${type}-${label}`}>
        <div
          id={id}
          style={{
            display: "inline-block", width: "15px", height: "15px", border: "1px solid rgba(125, 132, 146, 0.294)", cursor: "pointer",
            boxSizing: "border-box", background: value ? "#0466C8" : "#FFFFFF", borderRadius: "4px", justifyContent: "center", pointerEvents: disabled ? "none" : "initial"
          }}
          className="focus:outline-none"
          onClick={() => { onChange(!value) }}
          data-test-id={`checkbox-${type}-${label}-${value}`}
        >
          {value && (
            <div style={{ marginTop: "-1px", marginLeft: "-1px", display: "flex", alignItems: "center" }}>
              <svg viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 7.62163L6.62162 9.24325L9.86487 6.00001" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg></div>
          )}
        </div>
        <label
          onClick={() => { onChange(!value) }}
          htmlFor={id}
          className="checkbox-label"
          style={{fontWeight:value?700:600}}
        >
          {label}
        </label>
      </div>
    </div>
  );
};

interface ITopRightBottomLeft {
  id: string;
  label: string;
  custom?: boolean;
  style?: any;
  value: {
    overall: any;
    top: any;
    right: any;
    bottom: any;
    left: any;
  };
  onChange: (key: string, value: string | any) => void;
  disabled?: boolean;
}
export const TopRightBottomLeft: React.FC<ITopRightBottomLeft> = (
  props: any
) => {
  const { style, id, label, value, onChange, disabled, custom = false } = props;
  const [isExpanded, setIsExpanded] = useState(false);
  const { overall } = value;
  const handleChange = (id: string, val: string, item: any) => {
    if (custom) {
      onChange(id, { ...value, [item]: val });
    } else {
      const key = item === "overall" ? id : id + capitalize(item);
      onChange(key, val);
    }
  };
  return (
    <>
    <div className="panel-div">
      <Label label={label} id={id} />
      <div style={{width:170}} className="flex items-center">
        <input
          disabled={disabled}
          type="number"
          id="margin"
          value={overall}
          className="panel-input"
          style={{width: "140px"}}
          placeholder="0"
          min="0"
          onChange={(e:any) => {
            const changeValue = e.target.value;
            const value = changeValue ? Number(changeValue) > 0 ? changeValue : "0": changeValue;
            handleChange(id, value, "overall");
          }}
        // onChange={(e) => onChange(id, e.target.value)}
        />
        <div style={{marginLeft: "12px"}} onClick={() => setIsExpanded((prevState) => !prevState)}>
          {isExpanded ? (
            <ExpandDarkIcon
              className=" h-6 w-6 items-center cursor-pointer"
            />
          ) : (
            <ExpandIcon
              className="h-6 w-6 items-center cursor-pointer"
            />
          )}
        </div>
        </div>
    </div>
    {isExpanded && (
          <div className="flex ml-4 justify-end" style={{marginTop: 10}}>
            {Object.keys(value)
              .filter((item) => item !== "overall")
              .map((item) => {
                // const key = id + capitalize(item);
                const borderStyle = {
                  borderTop: `2px solid ${item === 'top' ? (((value as any)[item] && (value as any)[item] != 0) ? "rgba(241, 114, 46, 1)" : "#052f35 ") : "rgba(125, 132, 146, 0.294)"}`,
                  borderRight: `2px solid ${item === 'right' ? (((value as any)[item] && (value as any)[item] != 0) ? "rgba(241, 114, 46, 1)" : "#052f35 ") : "rgba(125, 132, 146, 0.294)"}`,
                  borderBottom: `2px solid ${item === 'bottom' ? (((value as any)[item] && (value as any)[item] != 0) ? "rgba(241, 114, 46, 1)" : "#052f35 ") : "rgba(125, 132, 146, 0.294)"}`,
                  borderLeft: `2px solid ${item === 'left' ? (((value as any)[item] && (value as any)[item] != 0) ? "rgba(241, 114, 46, 1)" : "#052f35 ") : "rgba(125, 132, 146, 0.294)"}`,
                }
                return (
                  <input
                    disabled={disabled}
                    type="number"
                    id={id}
                    style={{...borderStyle, height: "28px", borderRadius: "4px", cursor: style, marginLeft: "12.5px" }}
                    key={item}
                    className="bg-white text-gray-900 text-lg rounded-md  w-11 p-2.5 text-center dark:text-white focus:outline-none"
                    min="0"
                    placeholder="0"
                    onChange={(e: any) => {
                      const changeValue = e.target.value;
                      const value = changeValue ? Number(changeValue) > 0 ? changeValue : "0" : changeValue;
                      handleChange(id, value, item);
                    }}
                    // onChange={(e) => onChange(key, e.target.value)}
                    value={(value as any)[item]}
                  />
                );
              })}
          </div>
        )}
      </>
  );
};

interface IChartTemplate {
  options: { name: string }[];
  selected: { name: string };
  onChange: (option: { name: string; value?: string }) => void;
  disabled?: boolean;
  cursorStyle?: any;
  defaultValue?: any;
}
export const ChartTemplate: React.FC<IChartTemplate> = ({
  options,
  selected,
  onChange,
  disabled,
  cursorStyle,
  defaultValue
}) => {

  return (
    <Dropdown
      cursorStyle={disabled ? "not-allowed" : "auto"}
      disabled={disabled}
      options={options}
      selected={selected}
      onChange={onChange}
    />
  );
};


export const Wrapper: React.FC<{className?: string, children: React.ReactNode, testId?: string }> = ({
  className = "",
  children,
  testId,
}) => {
  return (
    <div
      className={`panel-div ${className}`}
      data-test-id={testId}
    >
      {children}
    </div>
  );
};